import(/* webpackMode: "eager", webpackExports: ["InstantQuote"] */ "/home/r11/choice-graphics/src/components/quote/instant-quote.tsx");
